var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import { getUriFromLinkByName } from "../helpers/LinkHelper";
import Embed from "./Embed";
import * as _ from "lodash";
import styled from 'styled-components';
import Icon from "./Icon";
import { fadeColor, getColor } from "../helpers/ColorHelpers";
var VideoContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        position: ", ";\n    "], ["\n        position: ", ";\n    "])), function (p) { return p.videoIcon ? "relative" : "unset"; });
var AudioContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position: relative;\n    background: ", ";\n    background-image: url('", "');\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: calc(100% - 5px);\n"], ["\n    position: relative;\n    background: ", ";\n    background-image: url('", "');\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: calc(100% - 5px);\n"])), function (p) { return getColor(p, "@veryLightGrey"); }, function (p) { return p.theme.emptyImageUrl; });
var ShineEffect = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n        position: absolute;\n        top:0;\n        left:0;\n        background: transparent;\n        transition: all 0.2s ease-out;\n        &:hover{\n        background: linear-gradient(130deg,rgba(0,0,0,0.3) 0%,rgba(0,0,0,0.4) 100%);\n        box-shadow: 0 5px 3px -4px #000;\n        }\n"], ["\n        position: absolute;\n        top:0;\n        left:0;\n        background: transparent;\n        transition: all 0.2s ease-out;\n        &:hover{\n        background: linear-gradient(130deg,rgba(0,0,0,0.3) 0%,rgba(0,0,0,0.4) 100%);\n        box-shadow: 0 5px 3px -4px #000;\n        }\n"])));
var HoverContainer = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n        position: ", ";\n        transition: ", ";\n        cursor: ", ";\n        opacity: 1;\n        &:hover{\n            opacity: ", ";\n        }\n"], ["\n        position: ", ";\n        transition: ", ";\n        cursor: ", ";\n        opacity: 1;\n        &:hover{\n            opacity: ", ";\n        }\n"])), function (p) { return p.hoverable ? "relative" : "unset"; }, function (p) { return p.hoverable ? "all 0.2s ease-out" : "none"; }, function (p) { return p.hoverable ? "pointer" : "default"; }, function (p) { return p.hoverable ? "1" : "1"; });
var IconContainer = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["                \n        position: absolute;\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%, -50%);\n        width: 100%;\n        height: 40px;\n        line-height: 40px;\n        text-align: center;\n        font-size: 17px;\n        color: rgba(255,255,255,0.9);\n        background: rgba(0,0,0,0.4);\n        letter-spacing: 3px;\n"], ["                \n        position: absolute;\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%, -50%);\n        width: 100%;\n        height: 40px;\n        line-height: 40px;\n        text-align: center;\n        font-size: 17px;\n        color: rgba(255,255,255,0.9);\n        background: rgba(0,0,0,0.4);\n        letter-spacing: 3px;\n"])));
var AudioContainerHeader = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 40px;\n        line-height: 40px;\n        font-size: 1rem;\n        color: ", ";\n        background: ", ";\n        padding: 0 0 0 15px;\n        svg{\n            stroke: ", ";\n        }\n"], ["\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 40px;\n        line-height: 40px;\n        font-size: 1rem;\n        color: ", ";\n        background: ", ";\n        padding: 0 0 0 15px;\n        svg{\n            stroke: ", ";\n        }\n"])), function (p) { return getColor(p, "@darkGrey"); }, function (p) { return fadeColor(p, getColor(p, "@darkGrey"), 5); }, function (p) { return getColor(p, "@darkGrey"); });
var Media = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    var _j = React.useState(0), pos = _j[0], setPos = _j[1];
    var _k = React.useState(false), hovered = _k[0], setHovered = _k[1];
    var _l = React.useState((_a = props.autoPlay) !== null && _a !== void 0 ? _a : false), play = _l[0], setPlay = _l[1];
    var _m = React.useState(), video = _m[0], setVideo = _m[1];
    var _o = React.useState(), audio = _o[0], setAudio = _o[1];
    var _p = props.autoPlay, autoPlay = _p === void 0 ? false : _p, controls = props.controls, onClick = props.onClick, _q = props.videoShift, videoShift = _q === void 0 ? 0.5 : _q, _r = props.audioShift, audioShift = _r === void 0 ? 0.5 : _r, _s = props.minChangeDelay, minChangeDelay = _s === void 0 ? 1000 : _s, _t = props.maxChangeDelay, maxChangeDelay = _t === void 0 ? 2000 : _t, media = props.media, videoIcon = props.videoIcon, hoverIcon = props.hoverIcon, hoverIconSize = props.hoverIconSize, hoverable = props.hoverable, rest = __rest(props, ["autoPlay", "controls", "onClick", "videoShift", "audioShift", "minChangeDelay", "maxChangeDelay", "media", "videoIcon", "hoverIcon", "hoverIconSize", "hoverable"]);
    var uri = "";
    var type = "";
    var sub = [];
    var thumb;
    var curMedia = _.isArray(media) ? media[pos] : media;
    React.useEffect(function () {
        var timeout = -1;
        if (_.isArray(media)) {
            var min = minChangeDelay;
            var max = maxChangeDelay;
            timeout = setTimeout(function () { return setPos((pos + 1) % media.length); }, Math.random() * (max - min) + min);
        }
        return function () { return clearTimeout(timeout); };
    }, [pos]);
    if (curMedia.hasOwnProperty("refName")) {
        var m = curMedia;
        uri = (_c = getUriFromLinkByName(m.media, (_b = m.refName) !== null && _b !== void 0 ? _b : "self")) !== null && _c !== void 0 ? _c : "";
        type = m.media.mediaType;
        thumb = m.media.thumbnails && m.media.thumbnails[0] ? ((_e = getUriFromLinkByName(m.media.thumbnails[0], (_d = m.refName) !== null && _d !== void 0 ? _d : "self")) !== null && _e !== void 0 ? _e : undefined) : undefined;
    }
    else if (curMedia.hasOwnProperty("file")) {
        var m = curMedia;
        uri = URL.createObjectURL(m.file);
        type = m.file.type;
    }
    else if (curMedia.hasOwnProperty("url")) {
        var m = curMedia;
        uri = m.url;
        type = m.type;
    }
    else {
        var m = curMedia;
        var click = function () {
            if (onClick)
                onClick(function () { });
        };
        return React.createElement(Embed, { id: m.id, source: m.source, autoPlay: autoPlay, onClick: click });
    }
    if (uri === undefined || uri === "")
        // empty image!
        return React.createElement("div", null);
    var videoMetaLoaded = function (event) {
        setVideo(event.currentTarget);
    };
    var audioMetaLoaded = function (event) {
        setAudio(event.currentTarget);
    };
    var canPlay = function () {
    };
    var imgOnclick = function () {
        var p = function () {
            if (thumb) {
                setPlay(true);
            }
        };
        if (onClick)
            onClick(p);
        else {
            p();
        }
    };
    if (type.startsWith("image") || (!autoPlay && !play && thumb)) {
        uri = thumb !== null && thumb !== void 0 ? thumb : uri;
        return ( // temporary implementation, for best practices
        React.createElement(HoverContainer, { hoverable: (_f = props.hoverable) !== null && _f !== void 0 ? _f : false },
            React.createElement("img", __assign({ key: uri, src: uri, className: "undefined" }, rest, { onClick: imgOnclick, onLoad: undefined, style: undefined, alt: "" })),
            props.hoverable &&
                React.createElement(React.Fragment, null,
                    React.createElement(ShineEffect, { style: { width: props.width, height: props.height }, onMouseOverCapture: function () { return setHovered(true); }, onMouseOutCapture: function () { return setHovered(false); }, onClick: imgOnclick }),
                    hovered &&
                        React.createElement(Icon, { name: hoverIcon !== null && hoverIcon !== void 0 ? hoverIcon : "search", size: hoverIconSize !== null && hoverIconSize !== void 0 ? hoverIconSize : "40px", color: "#FFF", style: { position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", pointerEvents: "none" } }))));
    }
    else if (type.startsWith("video")) {
        var togglePlay_1 = function () {
            if (video) {
                if (play)
                    video.play();
                else
                    video.pause();
            }
            setPlay(!play);
        };
        var videoOnClick = function () {
            if (onClick)
                onClick(togglePlay_1);
        };
        return (React.createElement(VideoContainer, { videoIcon: videoIcon !== null && videoIcon !== void 0 ? videoIcon : false },
            React.createElement("video", { crossOrigin: "anonymous", key: uri, controls: controls, autoPlay: autoPlay || play, controlsList: "nodownload", onLoadedMetadata: videoMetaLoaded, onCanPlay: canPlay, onClick: videoOnClick, style: { outline: "none" }, width: (_g = props.width) !== null && _g !== void 0 ? _g : "auto", height: (_h = props.height) !== null && _h !== void 0 ? _h : "auto" },
                React.createElement("source", { src: uri + "#t=" + videoShift, type: type })),
            videoIcon &&
                React.createElement(IconContainer, null,
                    React.createElement("div", { style: { width: "fit-content", margin: "auto" } },
                        "VIDE",
                        React.createElement(Icon, { name: "video player", style: { float: "right" }, size: "20px", color: "#FFF" })))));
    }
    else if (type.startsWith("audio")) {
        var togglePlay_2 = function () {
            if (audio) {
                if (play)
                    audio.play();
                else
                    audio.pause();
            }
            setPlay(!play);
        };
        var audioOnClick = function () {
            if (onClick)
                onClick(togglePlay_2);
        };
        return (React.createElement(AudioContainer, null,
            React.createElement(AudioContainerHeader, null,
                React.createElement(Icon, { name: "audio", style: { float: "left", marginRight: 10 } }),
                props.audioheadertext && React.createElement("span", null, props.audioheadertext)),
            React.createElement("audio", { crossOrigin: "anonymous", key: uri, controls: controls, autoPlay: autoPlay || play, controlsList: "nodownload", onLoadedMetadata: audioMetaLoaded, onCanPlay: canPlay, onClick: audioOnClick, style: { outline: "none", width: "100%", position: "absolute", bottom: 0, left: 0, height: 40, background: "#F1F3F4" } },
                React.createElement("source", { src: uri + "#t=" + audioShift, type: type }))));
    }
    return React.createElement("div", null);
};
export default Media;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=Media.js.map